<template>
  <div class="coffee-maker-fields" :class="{ 'is-compact': compact }">
    <img
      class="coffee-maker-photo"
      src="/static/room-coffee-maker.jpg"
      alt="Room coffee maker with coffee grounds, creamers, and pointe shoes"
      width="900"
      height="900"
      loading="lazy"
    >
    <p v-if="hint" class="coffee-hint">{{ hint }}</p>
    <div
      v-for="group in groups"
      :key="group.label"
      class="coffee-group"
    >
      <h3 class="coffee-subhead">{{ group.label }}</h3>
      <div class="iabf-chips">
        <button
          v-for="opt in group.options"
          :key="opt"
          type="button"
          class="iabf-chip"
          :class="{ 'is-selected': selected.includes(opt) }"
          @click="toggle(opt)"
        >
          {{ opt }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  COFFEE_MAKER_GROUPS,
  COFFEE_MAKER_NONE,
  toggleExclusiveNone
} from '@/config/iabf-dietary'

export default {
  name: 'CoffeeMakerFields',
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    hint: {
      type: String,
      default: 'Pick what you want in each row — or None if you’re set.'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groups () {
      return COFFEE_MAKER_GROUPS
    },
    selected () {
      return Array.isArray(this.value) ? this.value : []
    }
  },
  methods: {
    toggle (option) {
      this.$emit('input', toggleExclusiveNone(this.selected, option, COFFEE_MAKER_NONE))
    }
  }
}
</script>

<style scoped>
.coffee-maker-photo {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
  margin: 0 0 14px;
}
.is-compact .coffee-maker-photo {
  max-width: 280px;
  aspect-ratio: 1;
  margin-bottom: 12px;
}
.coffee-hint {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.45;
  color: var(--iabf-ink-muted, #5c5a63);
}
.coffee-group {
  margin-bottom: 16px;
}
.coffee-subhead {
  font-family: var(--iabf-font-body, inherit);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--iabf-ink-faint, #8a8792);
  margin: 0 0 8px;
  border: none;
  padding: 0;
}
</style>
